<template lang="pug">
div
  b-table(:data='data'
    v-if="data.length != 0"
    ref='table'
    paginated=''
    @page-change="pageChange"
    :narrowed="false"
    :total="totalDataTable"
    per-page='50'
    backend-pagination=''
    detailed
    hoverable
    :loading="isLoading"
    detail-key='id'
    aria-next-label='Página siguiente'
    aria-previous-label='Página anterior'
    aria-page-label='Página'
    aria-current-label='Página actual'
    )
    template(slot-scope='props')
      b-table-column(field='updated_at' label='Fecha modificación') {{ props.row.updated_at | formDate }}
        template(slot="header")
          div(class="header-wrapper")
            a(class="header-grid" @click="order('updated')") Fecha modificación
            div(v-if="updatedSense")  ↓
            div(v-if="!updatedSense") ↑
      b-table-column(field='code' label='Código' numeric) {{ props.row.code }}
        template(slot="header")
          div(class="header-wrapper")
            a(class="header-grid" @click="order('code')") Código
            div(v-if="codeSense")  ↓
            div(v-if="!codeSense") ↑
      b-table-column(field='client' label='Ramo' sortable) {{ props.row.name.split("COPY")[0]}}
      b-table-column(field='client' label='Broker' sortable) {{ props.row.quotation.broker || "---" }}
      b-table-column( v-if="roleExecutiveTeamSupervisor || roleNational" field='client' label='Ejecutivo' sortable) {{ props.row.assigned_executive_op || "---" }}
      b-table-column(v-if="roleNational" field='client' label='Supervisor' sortable) {{ props.row.assigned_executive_tsup || "---" }}
      b-table-column(field='client' label='Contratante' sortable) {{ props.row.quotation.client }}
      b-table-column(field='reference_premium' label='Prima Referencial') {{ premiumformat(props.row.reference_premium, props.row.reference_premium_currency) }}
        template(slot="header")
          div(class="header-wrapper")
            a(class="header-grid" @click="order('reference_premium')") Prima Referencial
            div(v-if="premiumSense")  ↓
            div(v-if="!premiumSense") ↑
      b-table-column(field='created_at' label='Fecha creación') {{ props.row.quotation.created_at | formDate }}
        template(slot="header")
          div(class="header-wrapper")
            a(class="header-grid" @click="order('created')") Fecha creación
            div(v-if="createdSense")  ↓
            div(v-if="!createdSense") ↑
      b-table-column(field='client' label='Recotización') {{ formatRequote(props.row.requote) }}
      b-table-column(field='client' label='# de Recot.') {{ props.row.requote_count || '0' }}
      b-table-column(field='client' label='Estado' sortable)
        span.tag(:class="getStatusClass(props.row.status, props.row.current_inbox, props.row.has_technical_quote, props.row.sender_inbox)") {{ props.row.status_name }}
    template(slot='detail' slot-scope='props')
      article.media
        .media-content
          .content
            .columns
              .column BROKER
                .field {{ props.row.quotation.broker.toUpperCase() }}
              .column(v-if="rolTechnical") COMERCIAL ASIGNADO
                .field {{ props.row.assigned_executive.toUpperCase() }}
              .column(v-for="field in props.row.values")
                field-reader(:data="field")
            .columns
              reallocation(
                :teamList="teamList"
                :quotation_id="props.row.id"
                :owner="props.row.owner"
                v-if="!roleEmission"
              )
              .column.is-1.button-wrapper
                b-button(
                  class="open-button"
                  size="is-small"
                  type="is-primary"
                  icon-left="eye" @click="openQuoteClickEvent(props.row)"
                ) ABRIR
  div(class="notfoundfilter-wrapper" v-if="showNoFoundFilter")
    img(class="image-wrapper" src="../assets/images/LoSentimos.svg")
    div(class="title-wrapper") Lo sentimos
    div(class="title-content") No encontramos resultados para tu búsqueda.
    div Intenta modificar los filtros.
</template>

<script>
import FieldReader from './fields/FieldReader';
import {RepositoryFactory} from '@/services/RepositoryFactory';
import { isTechnical, isExecutive, isEmission, isExecutiveNationalSupervisor, isExecutiveTeamSupervisor } from '@/mixins/user';
import { getExecutiveList } from '../services/User/executive';
import { getTechnicalList } from '../services/User/technical';
import Reallocation from './Reallocation';
import { isBroker } from '../mixins/user';
import { getBrokerList } from '../services/User/broker';
import store from "@/store";

const QuoteRepository = RepositoryFactory.get('quotes')

export default {
  components: {
    FieldReader,
    Reallocation
  },
  props: {
    filter: {
      type: String,
      default: 'inbox',
    }
  },
  data () {
    return {
      isLoading: true,
      teamList: [],
      premiumElement: null,
      field: "",
      page:1,
      updatedSense: false,
      codeSense: false,
      premiumSense: false,
      createdSense: false
    }
  },
  methods: {
    formatRequote(value) {
      let requote = ""
      value? requote ='Sí': requote ='No'
      return requote
    },
    order(field) {
      this.field = field
      if(field == "updated") {
        this.updatedSense = !this.updatedSense

        this.codeSense = false
        this.premiumSense = false
        this.createdSense = false
        store.dispatch('getListPage', {page:this.page, querys:`&ordering=${this.updatedSense? '':'-'}${field}`})
      } else if (field == "code") {
        this.codeSense = !this.codeSense

        this.premiumSense = false
        this.createdSense = false
        this.updatedSense = false
        store.dispatch('getListPage', {page:this.page, querys:`&ordering=${this.codeSense? '':'-'}${field}`})
      } else if ( field == "reference_premium") {
        this.premiumSense = !this.premiumSense

        this.codeSense = false
        this.createdSense = false
        this.updatedSense = false
        store.dispatch('getListPage', {page:this.page, querys:`&ordering=${this.premiumSense? '':'-'}${field}`})
      } else if ( field == "created") {
        this.createdSense = !this.createdSense

        this.codeSense = false
        this.premiumSense = false
        this.updatedSense = false
        store.dispatch('getListPage', {page:this.page, querys:`&ordering=${this.createdSense? '':'-'}${field}`})
      }
    },
    premiumformat(premium, currency) {
      if( premium ) {
        return `$ ${premium}`
      } else {
        return '---'
      }
    },
    fetchFilterBroker() {
      store.dispatch('fetchFilterBroker')
    },
    fetchDataTable() {
      store.dispatch('getListPage', {page:"1", querys:""})
    },
    pageChange(page) {
      this.page = page
      if( this.field ) {
        if(this.field == "updated") {
        store.dispatch('getListPage', {page:page, querys:`&ordering=${this.updatedSense? '':'-'}${this.field}`})
        } else if (this.field == "code") {
          store.dispatch('getListPage', {page:page, querys:`&ordering=${this.codeSense? '':'-'}${this.field}`})
        } else if (this.field == "reference_premium") {
          store.dispatch('getListPage', {page:page, querys:`&ordering=${this.premiumSense? '':'-'}${this.field}`})
        } else if (this.field == "created") {
          store.dispatch('getListPage', {page:page, querys:`&ordering=${this.createdSense? '':'-'}${this.field}`})
        }
      } else {
        store.dispatch('getListPage', {page:page, querys: store.state.queryToFilter})
      }
    },

    formatUpperCase(value) {
      const valueUpperCase = value.toUpperCase()
      return valueUpperCase
    },

    fetchData() {
      const quotes = QuoteRepository.getListPage(this.filter, 1)
      return quotes
    },

    getStatusClass (statusCode, currentInbox, hasTechnicalQuote, senderInbox ) {
      if (statusCode == 4 && (senderInbox == 1 || senderInbox == 2) )
        return 'is-broker-rejected'
      else if (statusCode == 2)
        return 'is-accepted'
      else if (isBroker() == true && (currentInbox == 2 || currentInbox == 3) )
        return 'is-lp-pending'
      else if (statusCode == 1 && currentInbox == 2 && hasTechnicalQuote == true  )
        return 'is-executive-quoted'
      else if (statusCode == 1 && currentInbox == 2 )
        return 'is-executive-pending'
      else if (statusCode == 3 && currentInbox == 1 )
        return 'is-broker-quoted'
      else if (statusCode == 1 && currentInbox == 1 )
        return 'is-broker-pending'
      else if (statusCode == 1 && currentInbox == 3 )
        return 'is-technical-pending'
      else if (statusCode == 5 && senderInbox == 3 )
        return 'is-technical-rejected'
      else if (statusCode == 5 && senderInbox == 2 )
        return 'is-executive-rejected'
      else if (statusCode == 5)
        return 'is-rejected'
    },

    openQuoteClickEvent(product) {
      this.$router.push({ name: 'QuotationDetail', params: { id: product.id }})
    },

    getTeamExecutiveList() {
      getExecutiveList('team/').then((result) => {
        this.teamList = result.data;
        store.commit('setTeamList', this.teamList)
      })
    },

    getTeamTechnicalList() {
      getTechnicalList('assignable/').then((result) => {
        this.teamList = result.data;
      })
    },

    getTeamBrokerList() {
      getBrokerList('team/').then((result) => {
        this.teamList = result.data;
      })
    }
  },
  async mounted() {
    store.commit('setCurrentTray', this.filter)
    await this.fetchDataTable()
    this.isLoading = false
    isExecutive() ? this.getTeamExecutiveList() : null;
    isTechnical() ? this.getTeamTechnicalList() : null;
    isBroker() ? this.getTeamBrokerList() : null;
    await this.fetchFilterBroker()
  },
  computed: {
    roleEmission() {
      return isEmission();
    },
    
    rolTechnical() {
      return isTechnical();
    },
    data() {
      return store.state.dataTable
    },
    totalDataTable() {
      return store.state.countDataTable
    },
    showNoFoundFilter() {
      return !store.state.thereFilterResults
    },
    roleNational() {
      return isExecutiveNationalSupervisor()
    },
    roleExecutiveTeamSupervisor() {
      return isExecutiveTeamSupervisor()
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
  .b-table {
    .table {
      th {
        text-transform: uppercase;
        padding: 1em 0.75em;
      }
      td {
        font-weight: 300;
        padding: 1em 0.75em;
        font-size: 12px;
      }
    }
  }
  .is-warning {
    background-color: $primary;
  }
  .button-wrapper{
    display: flex;
    align-items: flex-end;
  }
  .open-button{
    border-radius: 4px !important;
  }
  .field {
    font-weight: 300;
    font-size: 0.9em;
  }
  .notfoundfilter-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;
  }
  .image-wrapper {
    height: 150px;
    width: 150px;
  }
  .title-wrapper {
    font-size: 20px;
    font-weight: bold;
  }
  .title-content {
    font-size: 16px;
  }
  .header-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .header-grid {
    color: black;
  }
</style>
